module.exports = __webpack_public_path__ + "img/cu.b807bc5a.svg";